var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('PostContent',{attrs:{"post":_vm.post},scopedSlots:_vm._u([{key:"append-title",fn:function(){return [(_vm.formattedReleaseDate)?_c('p',{staticClass:"last-updated"},[_vm._v(" LAST UPDATED ON: "+_vm._s(_vm.formattedReleaseDate)+" ")]):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }